<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/38qbY0/tc-custom/9781453204726.jpg?1733088585402" alt="This image is the cover for the book Theory of Relativity"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Theory of Relativity
      </h1>
      <p class="bookDescription body article font2">
        <p><b>E=mc2 is the world’s most famous equation. Discover the thought process and physics behind general relativity and Einstein’s contribution to science, in this authorized edition.</b><br/><br/> In this collection of his seven most important essays on physics, Einstein guides his reader step-by-step through the many layers of scientific theory that formed a starting point for his discoveries. By both supporting and refuting the theories and scientific efforts of his predecessors, Einstein reveals in a clear voice the origins and meaning of such significant topics as physics and reality, the fundamentals of theoretical physics, the common language of science, the laws of science and of ethics, and an elementary derivation of the equivalence of mass and energy.<br/><br/> This remarkable collection allows the general reader to understand not only the significance of Einstein’s masterpiece, but also the brilliant mind behind it.<br/><br/><i>This authorized ebook features a new introduction by Neil Berger and an illustrated biography of Albert Einstein, which includes rare photos and never-before-seen documents from the Albert Einstein Archives at the Hebrew University of Jerusalem.</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Albert Einstein
      </h2>
      
      <p class="authorDescription body article"><p></p>Albert Einstein (1879&ndash;1955) was born in Germany and became an American citizen in 1940. A world-famous theoretical physicist, he was awarded the 1921 Nobel Prize for Physics and is renowned for his Theory of Relativity. In addition to his scientific work, Einstein was an influential humanist who spoke widely about politics, ethics, and social causes. After leaving Europe, Einstein taught at Princeton University. His theories were instrumental in shaping the atomic age.<p></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5eb61ac1